export interface ClientConfig {
    /** Duration of the map animation, in seconds */
    ANIMATION_DURATION: number;
    ASSET_MANIFEST?: string;
    CLIENT_PORT: number;
    GRAPHQL_ENDPOINT?: string;
    HOST: string;
    MAPBOX_ACCESS_TOKEN?: string;
    /** Indicates whether placeholder images should be shown instead of mapbox maps */
    MAPBOX_PLACEHOLDERS: boolean;
    MAPBOX_STYLESHEET: string;
    MAPBOX_USERNAME: string;
    NODE_ENV: string;
    PRIMARY_COLOR: string;
    /** Color for the map path and chart lines */
    THEME_COLOR: string;
    /** Application title */
    TITLE: string;
}

let config: ClientConfig | undefined;

/**
 * Creates or returns the runtime configuration settings
 * for the client
 */
export default (): ClientConfig => {
    if (config) {
        return config;
    }
    const env: any = process.env;

    config = {
        ANIMATION_DURATION: env.REACT_APP_ANIMATION_DURATION
            ? parseInt(env.REACT_APP_ANIMATION_DURATION, 10)
            : 60,
        ASSET_MANIFEST: env.REACT_APP_ASSET_MANIFEST || undefined,
        CLIENT_PORT: parseInt(env.REACT_APP_CLIENT_PORT || '0', 10) || 3000,
        GRAPHQL_ENDPOINT: env.REACT_APP_GRAPHQL_ENDPOINT || undefined,
        HOST: env.REACT_APP_HOST || 'localhost',
        MAPBOX_ACCESS_TOKEN: env.REACT_APP_MAPBOX_ACCESS_TOKEN || undefined,
        MAPBOX_PLACEHOLDERS: env.REACT_APP_MAPBOX_PLACEHOLDERS === 'true',
        MAPBOX_STYLESHEET: env.REACT_APP_MAPBOX_STYLESHEET || 'dark-v9',
        MAPBOX_USERNAME: env.REACT_APP_MAPBOX_USERNAME || 'mapbox',
        NODE_ENV: env.NODE_ENV || 'production',
        PRIMARY_COLOR: env.REACT_APP_PRIMARY_COLOR || '#3f92e8',
        THEME_COLOR: env.REACT_APP_THEME_COLOR || '#fc4c03',
        TITLE: env.REACT_APP_TITLE || 'Show me the running!'
    };

    return config;
};



// WEBPACK FOOTER //
// ./src/client/getClientEnvironment.ts